import { Logo } from '@/assets/svgIcons'
import { useAuth0 } from '@auth0/auth0-react'

const SessionExpired = () => {
  const { logout } = useAuth0()

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    })
  }
  return (
    <div className='relative flex py-3 px-6 flex-col justify-center items-center gap-6 h-screen border-[2px] border-[var(--border-opacity,rgba(255,255,255,0.90))] bg-primary backdrop-blur-[12px]'>
      <div className='absolute left-10 top-5'>
        <Logo />
      </div>
      <div className='flex p-[30px] flex-col justify-center items-center gap-3 rounded-radius-sm bg-[radial-gradient(80.89%_65.96%_at_96.67%_96.62%,rgba(0,94,204,0.12)_0%,rgba(0,0,0,0)_100%),_#FFF] shadow-[0_4px_24px_rgba(0,0,0,0.10)] backdrop-blur-[12px]'>
        <div>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='107'
            height='126'
            viewBox='0 0 107 126'
            fill='none'
          >
            <path
              d='M103.599 14.9832L54.176 0.155969C53.4838 -0.0519898 52.7464 -0.0519898 52.0543 0.155969L2.62974 14.9832C1.06948 15.4514 0 16.8887 0 18.5184V72.8846C0 79.9563 2.86265 87.1943 8.50836 94.3997C12.8202 99.9022 18.7855 105.428 26.2386 110.823C38.7588 119.886 51.0882 125.446 51.6068 125.677C52.0863 125.892 52.6009 126 53.1148 126C53.6294 126 54.1439 125.893 54.6234 125.677C55.1415 125.446 67.4703 119.886 79.9916 110.823C87.4441 105.428 93.4095 99.9022 97.7213 94.3997C103.367 87.1949 106.23 79.9563 106.23 72.8846V18.5184C106.23 16.8887 105.161 15.4514 103.599 14.9832Z'
              fill='#0062CC'
            />
            <path
              d='M77.8836 44.5234C79.0362 43.2964 83.5334 38.51 85.9189 35.9714'
              stroke='white'
              stroke-width='3.97895'
              stroke-linecap='round'
            />
            <path
              d='M83.4291 62.7514C84.9876 63.3877 91.0677 65.8709 94.2926 67.1882'
              stroke='white'
              stroke-width='3.97895'
              stroke-linecap='round'
            />
            <path
              d='M85.5331 52.4749C87.1608 52.0451 93.511 50.3692 96.8792 49.4805'
              stroke='white'
              stroke-width='3.97895'
              stroke-linecap='round'
            />
            <path
              d='M67.7295 54.0955L37.7088 53.4488C33.6519 53.3614 30.2605 56.6097 30.1731 60.6662L29.7516 80.2346C29.6642 84.2916 32.9125 87.6829 36.9695 87.7703L66.9901 88.417C71.0471 88.5044 74.4384 85.2561 74.5258 81.1992L74.9474 61.6308C75.0347 57.5743 71.7864 54.1829 67.7295 54.0955ZM52.2179 77.0396C49.2787 76.9763 46.9464 74.5412 47.0097 71.6016C47.073 68.6614 49.5081 66.33 52.4473 66.3934C55.3879 66.4567 57.7188 68.8908 57.6555 71.8309C57.5921 74.7706 55.1586 77.103 52.2179 77.0396Z'
              fill='white'
            />
            <path
              d='M40.4601 55.6387C39.3229 55.2419 38.5489 54.1172 38.6476 52.8597L39.1812 46.0356C39.7982 38.1631 46.7052 32.2604 54.5778 32.8768C62.4503 33.4938 68.3539 40.4 67.737 48.2725L67.2364 54.6542C67.1195 56.1511 65.8108 57.2694 64.3141 57.152C62.8187 57.0351 61.6998 55.7267 61.8172 54.23L62.3168 47.848C62.6992 42.9639 59.0376 38.6789 54.1536 38.2961C49.2696 37.9137 44.9842 41.5762 44.6014 46.4601L44.0672 53.2846C43.9504 54.781 42.6418 55.8993 41.145 55.7819C40.9061 55.7634 40.6765 55.7142 40.4601 55.6387Z'
              fill='white'
            />
          </svg>
        </div>
        <p className='text-primary-foreground text-center text-[2.375rem] font-semibold'>
          Session Expired
        </p>
        <p className='text-primary-foreground text-[1.25rem] max-w-[43.75rem] text-center'>
          For security purposes your session has expired after a period of
          inactivity. Please sign in again to continue.
        </p>
        {/* <div className='flex p-3 flex-col items-center justify-center gap-3 rounded-[7px] border border-[var(--secondary-border,rgba(0,0,0,0.30))] bg-[var(--info-dim,#CCE5FF)]'>
          <div className='flex flex-col justify-center items-center gap-3'>
            <p className='text-info-forground text-[20px] font-sans'>
              Still having issues please contact Spectrotel Customer Care
            </p>
            <div className='flex justify-center items-center gap-3'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M8.51244 5.33436C8.40619 5.08436 8.13119 4.94999 7.86869 5.01874L7.65931 5.07499C5.99681 5.53124 4.69057 7.09686 5.06869 8.91874C6.11244 13.9375 10.0656 17.8875 15.0843 18.9344C16.9031 19.3125 18.4718 18.0062 18.9249 16.3406L18.9812 16.1312C19.0531 15.8687 18.9187 15.5937 18.6656 15.4875L15.7499 14.2719C15.5281 14.1812 15.2749 14.2437 15.1218 14.4281L13.9781 15.825C13.8312 16.0031 13.5843 16.0594 13.3781 15.9594C11.0343 14.8469 9.15932 12.9094 8.12494 10.5219C8.03744 10.3156 8.09369 10.0781 8.26869 9.93749L9.56869 8.87186C9.75306 8.72186 9.81869 8.46561 9.72494 8.24374L8.51244 5.33436ZM7.60619 4.05624C8.35307 3.85311 9.13744 4.23436 9.43431 4.94999L10.6499 7.86561C10.9124 8.49374 10.7312 9.22186 10.2031 9.65311L9.19994 10.475C10.1062 12.3656 11.6093 13.9187 13.4593 14.8906L14.3499 13.8C14.7812 13.2719 15.5062 13.0906 16.1374 13.3531L19.0531 14.5687C19.7687 14.8656 20.1499 15.65 19.9468 16.3969L19.8906 16.6062C19.3374 18.6344 17.3499 20.425 14.8812 19.9125C9.47182 18.7875 5.21557 14.5312 4.09057 9.12186C3.57494 6.64999 5.36556 4.66561 7.39681 4.11249L7.60619 4.05624Z'
                  fill='black'
                />
              </svg>
              <p className='text-info-forground text-[18px] font-semibold'>
                888 773-9722
              </p>
            </div>
            <div className='flex justify-center items-center gap-3'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M4 7.82812V7.75H4.00313C4.04063 6.77812 4.84375 6 5.82812 6H18.1719C19.1562 6 19.9563 6.77812 19.9969 7.75H20V16C20 17.1031 19.1031 18 18 18H6C4.89688 18 4 17.1031 4 16V7.82812ZM19 9.4875L13.4781 13.5344C12.5969 14.1781 11.4 14.1781 10.5219 13.5344L5 9.4875V16C5 16.5531 5.44687 17 6 17H18C18.5531 17 19 16.5531 19 16V9.4875ZM19 7.82812C19 7.37188 18.6281 7 18.1719 7H5.82812C5.37188 7 5 7.37188 5 7.82812C5 8.09063 5.125 8.34062 5.3375 8.49687L11.1125 12.7281C11.6406 13.1156 12.3594 13.1156 12.8875 12.7281L18.6625 8.49375C18.875 8.3375 19 8.09063 19 7.825V7.82812Z'
                  fill='black'
                />
              </svg>
              <p className='text-info-forground text-[18px] font-semibold'>
                customercare@spectrotel.com
              </p>
            </div>
          </div>
        </div> */}
        <div
          className='flex py-[0.75rem] px-[1.5rem] items-center justify-center gap-[0.5rem] bg-accent hover:bg-info-hover text-primary rounded-[0.5rem] shadow-lg'
          onClick={handleLogout}
        >
          <button className='text-accent-foreground hover:underline text-[1.25rem] font-semibold'>
            Back to Login
          </button>
        </div>
      </div>
    </div>
  )
}
export default SessionExpired
